export const checkIsUsCountrySelected = (country: string | null | undefined) => {
  if (!country) {
    return false;
  }
  return /^\s*(?:USA?|U\.S\.(?:A\.?)?|United States(?: of America)?)\s*$/i.test(country);
};
